import script from "./screen4-header.vue?vue&type=script&setup=true&lang=js"
export * from "./screen4-header.vue?vue&type=script&setup=true&lang=js"

import "./screen4-header.vue?vue&type=style&index=0&id=2f897888&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f897888"]])

export default __exports__